export default "__VITE_PUBLIC_ASSET__56ab1c1f__"